import React, { useState, useEffect, useContext, Component, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useBlogContext } from '../../fetchdata/BlogContext';
import axiosInstance, { weburl } from '../../axiosInstance';
import getCookie from '../../helper/getCookie';
import setCookie from '../../helper/setCookie';
import getDecryptData from '../../helper/getDecryptData';
import LoginComponents from '../components/LoginComponents';
import HeaderPage from '../components/HeaderPage';
import NavBar from '../components/NavBar';


const CryptoJS = window.CryptoJS;


const Checkout = ({ updateAuthStatus }) => {

  const [useWallet, setUseWallet] = useState(false);

  const handleWalletChange = (e) => {
    setUseWallet(e.target.value === 'true');
  };

  const [pickupLocation, setPickupLocation] = useState('');
  const [PickupCoordinates, setPickupCoordinates] = useState({});

  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [ConfirmLocation, setConfirmLocation] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");


  const clearPickup = () => {
    setConfirmLocation(false);
    setPickupLocation("");
  };

  const handleSaveCurrentLocation = () => {
    const location = localStorage.getItem("selectedLocation");
    if (location) {
      setSelectedLocation(location);
      setPickupLocation(location);
      setPickupSuggestions([]);
    }
    setConfirmLocation(false);
  };



  // Function to handle click on search result
  const handleSearchPickupClick = (result) => {
    // toast.success('Location Update');
    setPickupSuggestions([]);
    setSelectedLocation(result.description);
    setPickupLocation(result.description);
    // localStorage.setItem('selectedLocation', result.description);
  };

  const handlePickupChange_old = (e) => {
    const value = e.target.value;
    setPickupLocation(value);

    if (value.trim() !== "" && pickupLocation !== "") {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions({ input: value }, (predictions) => {
        if (predictions) {
          const suggestedPlaces = predictions.map((prediction) => prediction);
          setPickupSuggestions(suggestedPlaces);
          console.log('suggestedPlaces', suggestedPlaces);
        }
      });
    } else {
      setPickupSuggestions([]);
    }
    setConfirmLocation(true);
  };

  const handlePickupChange = (e) => {
    const value = e.target.value;
    setPickupLocation(value);

    if (value.trim() !== "") {
      const autocompleteService = new window.google.maps.places.AutocompleteService();

      autocompleteService.getPlacePredictions({ input: value }, (predictions) => {
        if (predictions && predictions.length > 0) {
          const suggestedPlaces = predictions.map((prediction) => prediction);
          setPickupSuggestions(suggestedPlaces);
          console.log('Suggested Places:', suggestedPlaces);

          // OPTIONAL: Get lat/lng of the first prediction as an example
          const placeId = predictions[0].place_id;
          const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));

          const request = {
            placeId: placeId,
            fields: ['geometry', 'name'], // You can add more fields if needed
          };

          placesService.getDetails(request, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              const lat = place.geometry.location.lat();
              const lng = place.geometry.location.lng();
              console.log('Latitude:', lat, 'Longitude:', lng);

              // You can set this in state if needed:
              setPickupCoordinates({ lat, lng });
            }
          });
        }
      });
    } else {
      setPickupSuggestions([]);
    }

    setConfirmLocation(true);
  };


  const sanitizeInput = (input) => {
    // Implement your sanitization logic here
    return input.replace(/[^\w\s]/gi, '');
  };

  // Assuming countdown state is managed using useState hook
  const [countdown, setCountdown] = useState(0);



  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // Function to pad the plaintext
  function pkcs5_pad(text, blocksize) {
    var padding = blocksize - (text.length % blocksize);
    for (var i = 0; i < padding; i++) {
      text += String.fromCharCode(padding);
    }
    return text;
  }

  // Function to encrypt plaintext
  function encrypt(plainText, key) {
    // Convert key to MD5 and then to binary
    var secretKey = CryptoJS.enc.Hex.parse(CryptoJS.MD5(key).toString(CryptoJS.enc.Hex));
    // Initialize the initialization vector
    var initVector = CryptoJS.enc.Utf8.parse(Array(16).fill(0).map((_, i) => String.fromCharCode(i)).join(''));
    // Pad the plaintext
    var plainPad = pkcs5_pad(plainText, 16);
    // Encrypt using AES-128 in CBC mode
    var encryptedText = CryptoJS.AES.encrypt(plainPad, secretKey, { iv: initVector, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.NoPadding });
    // Convert the ciphertext to hexadecimal
    return encryptedText.ciphertext.toString(CryptoJS.enc.Hex);
  }

  // Function to decrypt ciphertext
  function decrypt(encryptedText, key) {
    // Convert key to MD5 and then to binary
    var secretKey = CryptoJS.enc.Hex.parse(CryptoJS.MD5(key).toString(CryptoJS.enc.Hex));
    // Initialize the initialization vector
    var initVector = CryptoJS.enc.Utf8.parse(Array(16).fill(0).map((_, i) => String.fromCharCode(i)).join(''));
    // Convert the encryptedText from hexadecimal to binary
    var encryptedData = CryptoJS.enc.Hex.parse(encryptedText);
    // Decrypt using AES-128 in CBC mode
    var decryptedText = CryptoJS.AES.decrypt({ ciphertext: encryptedData }, secretKey, { iv: initVector, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.NoPadding });
    // Remove PKCS#5 padding
    return decryptedText.toString(CryptoJS.enc.Utf8).replace(/[\x00-\x1F\x80-\xFF]+$/g, '');
  }





  const [loading, setLoading] = useState(false); // Add loading state
  const [data, setData] = useState([]);
  const [FinalAmount, setFinalAmount] = useState(0); // Add loading state
  const [getTax, setTax] = useState([]);
  const [getStateName, setStateName] = useState('');
  const [getPrimaryName, setPrimaryName] = useState(false);
  const [orderProcess, setOrderProcess] = useState(false);

  const [getStateId, setStateId] = useState(false);


  const [mode, setMode] = useState('');



  const [GetEmailOTP, setEmailOTP] = useState(null); // Add loading state
  const [EmailVerify, setEmailVerify] = useState(false); // Add loading state



  const [getUserData, setUserData] = useState({
    username: '',
    phone: '',
    email: '',
    address: '',
    pincode: '',
  });


  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [GetOtpRes, setOtpRes] = useState([]); // Add loading state
  const [GetOtpTyp, setOtpTyp] = useState([]); // Add loading state
  const [hasPassword, setPassword] = useState(false); // Add loading state

  const [GetcartItems, setcartItems] = useState([]); // Add loading state



  const handleModeChange = (e) => {
    setMode(e.target.value);
  };



  const { cartItems, IsUserData, Headers, isHeader, removeItemFromCart, totalAmount, clearAllItemsInCart, updateItemQuantity, getTotalAmount, removePromoCode, getTotalItems, applyPromoCode, promoCodeInfo, mypromoCode, sendMessage } = useBlogContext();

  // console.log('cartItems', cartItems); // Log cartItems to console for debugging
  const mycartItems = cartItems;


  const [promoCode, setPromoCode] = useState(''); // State to hold the entered promo code

  const handleRemovePromoCode = () => {
    toast.success('Promo code removed')
    removePromoCode();
  };

  // Function to handle applying promo code
  const handleApplyPromoCode = () => {
    applyPromoCode(promoCode); // Call the applyPromoCode function with the entered promo code
  };



  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => {


    if (EmailVerify) {
      setCurrentStep(currentStep + 1);
    } else {
      setCurrentStep(currentStep + 1);

      toast.error('Need to verify email first ')
    }

  };

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };



  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const isLoginFromLocalStorage = localStorage.getItem('token') ? true : false;
  const isLoginFromLocalStorage = getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const [isLoginForm, setIsLoginForm] = useState(true); // State to manage which form to display
  const [shippingCharge, setshippingCharge] = useState(''); // State to manage which form to display


  const toggleForm = () => {
    setIsLoginForm(prevState => !prevState); // Toggle between login and signup forms
  };


  const [showModal, setShowModal] = useState(false);

  const [PaymentMethod, setPaymentMethod] = useState('');

  const handlePaymentMethodChange = (event) => {
    const { id, checked } = event.target;
    setPaymentMethod(prevState => {
      if (checked) {
        // Add checkbox id to the state string
        return prevState + id + ',';
      } else {
        // Remove checkbox id from the state string
        return prevState.replace(id + ',', '');
      }
    });

  };

  // Function to check if a checkbox is checked
  const isCheckPaymentMethodChecked = (id) => {
    return PaymentMethod.includes(id);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const getTotalFinalAmount = (weight, shippingRatesStr) => {
    //  console.log(shippingRatesStr)
    if (shippingRatesStr.length !== 0) {
      // Parse the shipping rates string into an array of rate objects
      const shippingRates = shippingRatesStr.split(',').map(rateStr => {
        const [rangeStr, chargeStr] = rateStr.split(':');
        const [minWeightStr, maxWeightStr] = rangeStr.split('-');
        return {
          minWeight: parseFloat(minWeightStr),
          maxWeight: parseFloat(maxWeightStr),
          charge: parseFloat(chargeStr)
        };
      });

      // Find the shipping rate that matches the weight range
      const rate = shippingRates.find(rate => weight >= rate.minWeight && weight <= rate.maxWeight);

      // If a matching rate is found, return the corresponding charge
      if (rate) {
        setshippingCharge(rate.charge);
        //  console.log('shippingRates', rate.charge)
      } else {
        setshippingCharge(0);
        return 0; // Return a default charge or handle the case as needed
      }

    } else {
      setshippingCharge(0);
      return 0; // Return a default charge or handle the case as needed

    }

    // setFinalAmount(discountedAmount);
  };



  // const calculateShippingCharge = (weight, shippingRates) => {
  //   // Find the shipping rate that matches the weight range
  //   const rate = shippingRates.find(rate => weight >= rate.minWeight && weight <= rate.maxWeight);

  //   // If a matching rate is found, return the corresponding charge
  //   if (rate) {
  //     return rate.charge;
  //   } else {
  //     // If no matching rate is found, return a default charge or handle the case as needed
  //     return 0; // Return 0 or handle the case as needed
  //   }
  // };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/get-all-zones");
      //  console.log(response.data.Zones);
      setData(response.data.Zones);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData()

  }, []);




  useEffect(() => {
    if (promoCodeInfo) {
      console.log('promoCodeInfo', promoCodeInfo)
    }
  }, [promoCodeInfo]);


  useEffect(() => {
    const checkUserToken = async () => {
      console.log('Effect is running');
      // Check if this is printed multiple times
      //  const usertoken = localStorage.getItem('token');
      const usertoken = getCookie('token');

      if (usertoken) {
        console.log('Token found in local storage'); // Check if this is printed multiple times

        // toast.success("Welcome back");
      }
    }
    checkUserToken();
  }, [dispatch, navigate]);


  const [inputs, setInputs] = useState({
    username: '',
    email: '',
    password: '',
  });

  // const userString = localStorage.getItem('user');
  const userString = getCookie('user');


  let initialUserData = {
    username: '',
    phone: '',
    pincode: '',
    state: '',
    address: ''
  };

  if (userString) {
    const { username, phone, pincode, country, address } = JSON.parse(userString);
    // Use user information from localStorage as initial data
    initialUserData = { username, phone, pincode, country, address };
  }



  // Set initial state using retrieved user information
  const [Orderinputs, setOrderInputs] = useState(initialUserData);

  const [Ordercart, setOrderCart] = useState({});

  const Ordercredentials = {
    phone: Orderinputs.phone,
    pincode: Orderinputs.pincode,
    country: Orderinputs.country,
    address: Orderinputs.address,
    items: cartItems,
    status: '1',
    mode: 'COD',
    details: {
      username: Orderinputs.username,
      phone: Orderinputs.phone,
      pincode: Orderinputs.pincode,
      state: getStateName,
      address: Orderinputs.address,
      email: Orderinputs.email,
    },
    discount: '',
    shipping: '',
    totalAmount: '',
    primary: getPrimaryName,
    payment: 0,
  };



  const fetchtaxData = async (id) => {
    // setLoading(true); // Set loading to false when data is fetched
    // console.log('fetchtaxData')
    // try {
    //   const { data } = await axiosInstance.get(`/get-tax/${id}`);
    //   console.log('tax data', data.tax)
    //   setTax(data.tax);
    //   let weight = await mycartItems.reduce((total, item) => total + item.quantity * item.weight, 0);
    //   getTotalFinalAmount(weight, data.tax?.rate ?? []);

    //   // setStateName(data.tax?.name ?? '')
    //   console.log('weight', weight)
    // }
    // catch (error) {
    //   console.log(error);
    //   toast.error("Error fetching Shipping!");

    // } finally {
    //   setLoading(false); // Set loading to false when data is fetched

    // }
  };


  //handle input change
  const handleOrderChange = (e) => {

    console.log('e.target.name', e.target.name)
    let sanitizedValue = e.target.value;
    if (e.target.name !== 'email') {
      sanitizedValue = sanitizeInput(e.target.value);
    }


    setOrderInputs((prevState) => ({
      ...prevState,
      [e.target.name]: sanitizedValue,
    }));

  };

  const [paymentForm, setPaymentForm] = useState('');


  //form handle
  const handleOrderSubmit = async (e) => {

    if (!mode && mode !== '') {

      toast.error('Please Choose Payment Method');


    }
    else {

      if (!Orderinputs.username || !Orderinputs.phone || !Orderinputs.email || !Orderinputs.pincode || !Orderinputs.address) {
        if (!Orderinputs.state) {
          toast.error('Please Select State');
        } else {
          toast.error('Please Fill All Details');
        }
        handlePrevious();
        console.log(Orderinputs.pincode, Orderinputs.country, Orderinputs.address)
      }
      else {

        if (!mode) {
          toast.error('Please Choose Payment Mode');
          return null;
        }

        const decryptdatajson = getDecryptData();
        //  const userId = localStorage.getItem('userId');
        const userId = decryptdatajson._id;


        e.preventDefault();


        const shipping = shippingCharge ? shippingCharge : 0;

        let Total;
        let discount;
        if (!useWallet && promoCodeInfo && promoCodeInfo.type && promoCodeInfo.discount > 0) {
          Total = totalAmount + shippingCharge;
          discount = totalAmount - cartItems.reduce((total, item) => total + item.quantity * item.price, 0)

        } else {
          Total = shippingCharge + cartItems.reduce((total, item) => total + item.quantity * item.price, 0);
          discount = 0;
        }

        const updatedFormData = {
          ...Ordercredentials,
          phone: Orderinputs.phone,
          pincode: Orderinputs.pincode,
          address: Orderinputs.address,
          username: Orderinputs.username,
          email: Orderinputs.email,
          useWallet: useWallet ? 1 : 0,
          mode: mode,
          userId: userId,
          totalAmount: Total,
          discount: discount,
          shipping: shipping,
          primary: getPrimaryName,
          payment: 1,
          state: Orderinputs.state,
          verified: 1,
        };


        console.log('updatedFormData', updatedFormData)


        try {

          setOrderProcess(true);


          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          // Check if the email in formData is valid
          if (!emailRegex.test(Orderinputs.email)) {
            // Invalid email format
            // Handle this case accordingly, such as displaying an error message
            toast.error('Invalid email format');
            return; // Stop further execution
          }

          const response = await axiosInstance.post(`/create-order/${userId}`, updatedFormData);

          console.log('order.data', response.data);
          const { success, meta_logo, keyId, newOrder, wallet, Amount } = response.data;


          if (success) {

            clearAllItemsInCart(); // Call the function to clear all items in the cart
            removePromoCode();

            // const sendmsg = { userId: newOrder?.userId[0], type: "book", order: newOrder, orderId: newOrder?.orderId };
            // await sendMessage(sendmsg);
            if (!wallet && response && response.data && mode !== "COD") {

              const options = {
                key: keyId,
                amount: Number(Amount * 100),
                currency: "INR",
                name: Headers?.meta_title || 'unknown',
                description: Headers?.meta_description || 'unknown',
                image: meta_logo,
                order_id: newOrder.razorpay_order_id,
                callback_url: `${weburl}order-payment-app-verification`,
                // prefill: {
                //   name: "test gupta",
                //   email: "test@gmail.com",
                //   contact: "1234567890",
                // },
                notes: {
                  address: "razorapy official",
                },
                theme: {
                  color: "#3399cc",
                },
              };
              const razor = new window.Razorpay(options);
              razor.open();


            } else if (response.data.success === true && wallet) {
              // clearAllItemsInCart(); // Call the function to clear all items in the cart
              // removePromoCode();
              navigate('/account/all-order');
            }
          }



        } catch (error) {
          console.error('Error during login:', error);
          // Handle network errors, API issues, etc.
          toast.error(error.response.data.message);

        } finally {
          setOrderProcess(false);
        }



      }

    }

  };



  //form handle
  const verifyemail = async () => {
    toast.success("OTP Send to your email address");
    try {
      const { data, success } = await axiosInstance.post('/email-verify', Orderinputs);
      if (data) {
        setEmailOTP(data.OTP);
      }
    } catch (error) {
      console.error('Error during verifyemail:', error);
      toast.error("Error while Sending OTP");
    }
  };


  const CheckEmail = async () => {
    if (GetEmailOTP === null) {
      toast.error("OTP Not Verifed");
    }
    else if (Orderinputs.EmailOTP.toString() === GetEmailOTP.toString()) {

      toast.success("OTP Verifed");
      setEmailVerify(true);

    } else {
      toast.error("OTP Not Verifed");

    }

  }


  const [combinedOTP, setcombinedOTP] = useState(""); // Add loading state






  useEffect(() => {
    setIsLogin(isLoginFromLocalStorage);
  }, [isLoginFromLocalStorage, dispatch]);


  useEffect(() => {


    if (isLogin === true) {



      //form handle
      const fetchUserById = async () => {

        const decryptdatajson = getDecryptData();


        const credentials = {
          id: decryptdatajson._id,
        };

        try {
          const { data } = await axiosInstance.post('/auth-user', credentials);
          const { success, token, existingUser, message } = data;

          if (success) {



            setOrderInputs((prevData) => ({
              ...prevData,
              username: existingUser.username || '',
              phone: existingUser.phone || '',
              email: existingUser.email || '',
              address: existingUser.address || '',
              pincode: existingUser.pincode || '',
              state: existingUser.state || '',

            }));

            if (existingUser && existingUser.verified === 1) {
              setEmailVerify(true)
            }
            setStateId(existingUser.state);
            //   console.log("Message from backend:", existingUser);
          }


        } catch (error) {
          console.error('Error during login:', error);
          // Handle network errors, API issues, etc.
          toast.error(error.response.data.message);

        }
      };
      fetchUserById();
    }

  }, [isLogin]);

  useEffect(() => {
    if (getStateId !== false) {
      fetchtaxData(getStateId);
      const status = data.find(data => data._id === getStateId)?.primary;
      const Sname = data.find(data => data._id === getStateId)?.name;

      if (status === 'true' || status === 'false') {
        setPrimaryName(status);
        setStateName(Sname);
      }

    }

  }, [getStateId]);




  return (


    <>

      <HeaderPage title={'Checkout'} />

      <main className="page-content  mypadding bg-light overflow-auto pb-4 px-0" >


        <div className=" px-3 py-2">
          <div className="row g-1" style={{ position: "relative" }} >

            {loading === 0 && (
              <>
                <div
                  className=""
                  style={{
                    width: "100%",
                    borderRadius: 5,
                    margin: 0,
                    height: "100%",
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9,
                    background: 'white',
                    left: 0,
                    top: 0,
                    color: "white",
                    fontSize: "20em"
                  }}
                >
                  <div class="loading_icon"></div>
                </div>

              </>)}

            {orderProcess && (<>
              <div
                className="orderpanel"
                style={{
                  width: "100%",
                  borderRadius: 5,
                  margin: 0,
                  height: "100%",
                  position: "fixed",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                  background: "#ffffffa1",
                  left: 0,
                  top: 0,
                  color: "white",

                }}
              >
                <div className="page text-center">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <div className="loader-outer">
                        <div className="loader" />
                      </div>
                      <h2 className='text-dark'>PROCESSING YOUR ORDER</h2>
                    </div>
                    <div className="panel-body">
                      <p className='text-dark' >
                        Hold tight, your order is being processed, please do not navigate away
                        from the current window or refresh the page.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </>)}



            {currentStep === 2 && (


              !isHeader ? (<>

                <h5> Choose payment Method</h5>

                {Headers.cash === 'true' && (
                  <div className="accordion mb-4" id="payment-method">

                    <div className="accordion-item ">
                      <h3 className="accordion-header">

                        <div className="form-check accordion-button collapsed"

                        >

                          <input className="form-check-input fs-lg me-2 ms-0 align-right"
                            value="COD"
                            onChange={handleModeChange}
                            name="mode" type="radio" id="COD"
                            checked={mode === "COD"}
                          />
                          <label
                            className="form-check-label widget-filter-item-label w-100"
                            htmlFor="COD"
                          >
                            Pay Later
                          </label>

                        </div>

                      </h3>


                    </div>
                  </div>
                )}
                {Headers.razorpay === 'true' && (

                  <div className="accordion mb-4" id="payment-method">

                    <div className="accordion-item ">
                      <h3 className="accordion-header">

                        <div className="form-check accordion-button collapsed"
                        >

                          <input className="form-check-input fs-lg me-2 ms-0 align-right"
                            value="Online"
                            onChange={handleModeChange}
                            name="mode"
                            type="radio"
                            id="Online"
                            checked={mode === "Online"}
                          />
                          <label
                            className="form-check-label widget-filter-item-label w-100"
                            htmlFor="Online"
                          >
                            Pay Online
                          </label>

                        </div>

                      </h3>


                    </div>


                  </div>
                )}

                {(Headers.cash !== 'true' && Headers.razorpay !== 'true') && <p className='text-danger h5'>
                  <i className="ri-error-warning-fill me-1 fw-light" />
                  Something went wrong with the payment gateway. Please try again later.</p>}

              </>) : (<> Payment Method Loading... </>)




            )}

            <div className="col-12">
              <div
                className="card border"

              >
                <div className="card-body">
                  {/* Product */}


                  {cartItems.map((item) => (


                    <>
                      <div className="mb-4">
                        <div className="d-flex align-items-center pb-2 border-bottom">
                          <Link className="d-block flex-shrink-0" to={`/product/${item.id}`}>
                            <img src={item.image} width={60} height={60} className='rounded' style={{ aspectRatio: '1/1', objectFit: 'cover' }}
                              alt="Product" />
                          </Link>
                          <div className="ps-2">
                            <h6 className="fs-md mb-1">
                              <Link to={`/product/${item.id}`} className="link-hover-primary">
                                {item.title} - {item.color}
                              </Link>
                            </h6>
                            <div className="fs-sm">
                              <span className="text-accent me-2">₹{item.price}</span>
                              <span className="text-body-secondary">Quantity: </span>
                              <span className="text-body-secondary">{item.quantity}</span>
                            </div>

                            <div className="fs-sm">

                              <span className="text-body-secondary">Total Price: </span>
                              <span className="text-body-secondary">₹{item.quantity * item.price}</span>
                            </div>


                          </div>
                        </div>
                      </div>
                      {/* Product */}



                    </>
                  ))}



                  {cartItems && cartItems.length > 0 ? (
                    <>

                      {!useWallet && promoCodeInfo && promoCodeInfo.type && promoCodeInfo.discount > 0 ? (<>
                        <div className="d-flex align-items-center justify-content-between">
                          <p>Sub Total </p>
                          <p>₹{cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}</p>
                        </div>

                        <div className="d-flex align-items-center justify-content-between">
                          <p >Discount </p>
                          <p>{totalAmount - cartItems.reduce((total, item) => total + item.quantity * item.price, 0) < 0
                            ? `- ₹${Math.abs(totalAmount - cartItems.reduce((total, item) => total + item.quantity * item.price, 0))}`
                            : `₹${totalAmount - cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}`
                          }</p>

                        </div>


                        <div className="d-flex align-items-center justify-content-between">
                          <p >Shipping  </p>
                          <p>+ ₹  {shippingCharge ? shippingCharge : 0}</p>

                        </div>

                        <div className="d-flex align-items-center justify-content-between">
                          <h5> Total </h5>
                          <h5>₹ {totalAmount + shippingCharge}
                            {/* {String(FinalAmount) === '0' ? cartItems.reduce((total, item) => total + item.quantity * item.price, 0) - FinalAmount} */}
                          </h5>
                        </div>

                        <div className="d-flex align-items-center justify-content-between mypromobox mb-2">
                          <div className="d-flex align-items-center justify-content-between gap-2" >
                            <i class="ri-checkbox-circle-line text-success h4"></i>

                            <p className='m-0'> <b> {mypromoCode} </b>  applied <br />
                              {promoCodeInfo.type === "percentage" ? (<>
                                {promoCodeInfo.discount * 100}% OFF
                              </>) : (<>
                                ₹{promoCodeInfo.discount} OFF
                              </>)}  </p>

                          </div>

                          <button type="button" className="btn btn-danger p-2" onClick={handleRemovePromoCode}>
                            {" "}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={16}
                              height={16}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#ffffff"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="3 6 5 6 21 6" />
                              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                              <line x1={10} y1={11} x2={10} y2={17} />
                              <line x1={14} y1={11} x2={14} y2={17} />
                            </svg>{" "}
                          </button>


                        </div>

                      </>) : (<>


                        {useWallet ?
                          <>

                            <div className="d-flex align-items-center justify-content-between">
                              <p>Sub Total </p>
                              <p>₹{cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}</p>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                              <p >Discount </p>
                              <p>-{IsUserData.wallet}</p>

                            </div>


                            <div className="d-flex align-items-center justify-content-between">
                              <p >Shipping  </p>
                              <p>+ ₹  {shippingCharge ? shippingCharge : 0}</p>

                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                              <h5> Total </h5>
                              <h5>₹ {(shippingCharge + cartItems.reduce((total, item) => total + item.quantity * item.price, 0)) - IsUserData.wallet}
                              </h5>
                            </div>

                          </> : <>

                            {/* Subtotal */}
                            <ul className="list-unstyled fs-sm border-bottom pb-4 mb-4">
                              <li className="d-flex align-items-center justify-content-between mb-1">
                                <span className="me-2">Subtotal:</span>
                                <span className="text-end">₹{cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}</span>
                              </li>

                              <li className="d-flex align-items-center justify-content-between">
                                <span className="me-2">Shipping:</span>
                                <span className="text-end"> + ₹ {shippingCharge ? shippingCharge : 0}</span>
                              </li>
                            </ul>


                            <div className="d-flex align-items-center justify-content-between">


                              <h5> Total </h5>
                              <h5>  {cartItems.length > 0 && (
                                <>  ₹{shippingCharge + cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}
                                </>
                              )} </h5>
                            </div>

                          </>
                        }




                        {!useWallet &&
                          <>
                            <hr className="mb-4" />
                            <div className="col-auto mb-3">
                              <div className="input-group">
                                <input id="promoCode1" type="text" className="form-control border" onChange={(e) => setPromoCode(e.target.value)} placeholder="Promo code" value={promoCode} />
                                <button className="btn btn-primary" onClick={handleApplyPromoCode} type="button" id="button-promo">Apply</button>
                              </div>
                            </div>
                          </>
                        }

                      </>
                      )}




                      <div className="border p-3 rounded d-flex align-items-center justify-content-between">

                        {/* Left section: Icon + Text */}
                        <div className="d-flex align-items-center gap-3">

                          {/* Icon Box */}
                          <div className="border rounded p-2 d-inline-flex align-items-center justify-content-center"
                            style={{ width: 50, height: 50 }}>
                            <i className="ri-wallet-fill fs-3"></i>
                          </div>

                          {/* Text Section */}
                          <div>
                            <div className="d-flex align-items-center gap-1">
                              <span className="fw-semibold fs-5">Wallet</span>
                              <i className="ri-information-line" style={{ fontSize: '18px', color: '#999' }}></i>
                            </div>
                            <small className="text-muted">Wallet balance: {IsUserData.wallet || 0}</small>
                          </div>

                        </div>

                        {/* Switch */}
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input shadow-none"
                            type="checkbox"
                            role="switch"
                            id="walletSwitch"
                            checked={useWallet}
                            onChange={(e) => setUseWallet(e.target.checked)}
                            style={{ transform: "scale(1.4)" }}
                          />
                        </div>

                      </div>

                    </>
                  ) : (<>
                    <Link className="btn btn-primary btn-shadow d-block w-100" to="/">Shop Now</Link>
                  </>)}


                </div>
              </div>
            </div>

            <div className="col-lg-12">

              {currentStep === 1 && (
                <>

                  {/* Steps */}
                  <div className="border rounded-3 p-4 bg-white">
                    {/* Alert */}
                    <div
                      className="alert alert-success alert-dismissible fade show d-none"
                      role="alert"
                    >


                      <a className="fw-medium" href="#" data-toggle="modal" data-target="#LoginModel" >
                        Login
                      </a>{" "}
                      or{" "}
                      <a className="fw-medium" href="#" data-toggle="modal" data-target="#RegisterModel" >
                        Register
                      </a>{" "}
                      for faster payment.{" "}
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                      />
                    </div>
                    {/* Alert */}



                    {!isLogin && (<>

                      <div
                        className=" m-auto rounded-3 shadow p-4 bg-white"
                        style={{ maxWidth: 450, minHeight: 400 }}
                      >
                        <LoginComponents updateAuth={updateAuthStatus} />

                      </div>




                    </>)}




                    {isLogin ? (<>

                      {/* <button onClick={ordertest}>Test Order</button> */}
                      <h4 className='CapiTaliZed '>Welcome Back {Orderinputs?.username}</h4>

                      {Orderinputs.phone ? (
                        <>
                          <div className="row">


                            <div className="col-md-12">
                              <div className="mb-4">
                                <label className="form-label" htmlFor="username">
                                  Full Name
                                </label>
                                <input className="form-control" type="text" id="username"
                                  name="username"
                                  value={Orderinputs.username}
                                  onChange={handleOrderChange} />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-4">
                                <label className="form-label" htmlFor="phone">
                                  Phone No.
                                </label>
                                <input className="form-control bg-light" type="number" id="phone" readOnly
                                  name="phone"
                                  value={Orderinputs.phone}
                                />
                              </div>
                            </div>


                            <div className="col-md-6">
                              <div className="mb-4">
                                <label className="form-label" htmlFor="Email">
                                  Email
                                </label>
                                <div className="input-group">

                                  <input className="form-control" type="email" id="Email" name="email"
                                    value={Orderinputs.email}
                                    onChange={handleOrderChange} />
                                  {!EmailVerify && (<button className="btn btn-danger" onClick={verifyemail} type="button"  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={20}
                                      height={20}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#ffffff"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    >
                                      <circle cx={12} cy={12} r={10} />
                                      <line x1={12} y1={8} x2={12} y2={12} />
                                      <line x1={12} y1={16} x2="12.01" y2={16} />
                                    </svg>
                                    {' '} Verify
                                  </button>)}

                                </div>

                              </div>
                              {!EmailVerify && GetEmailOTP && (
                                <>
                                  <div className='bg-light p-2 mb-2 rounded'>
                                    <label> OTP Send to your email address </label>

                                    <div className="input-group my-3">
                                      <input
                                        type="number"
                                        className="form-control form-control-sm "
                                        placeholder="Enter OTP"
                                        name='EmailOTP'
                                        value={Orderinputs.EmailOTP}
                                        onChange={handleOrderChange}
                                        onKeyPress={(e) => { if (e.target.value.length === 4) e.preventDefault(); }}

                                      />
                                      <button
                                        className="btn btn-success btn-sm"
                                        type="button"
                                        onClick={CheckEmail}
                                      >
                                        Submit
                                      </button>
                                    </div>


                                  </div>
                                </>
                              )}



                            </div>


                            <div className="col-md-6">
                              <div className="mb-4">
                                <label className="form-label" htmlFor="pincode">
                                  Pincode
                                </label>
                                <input className="form-control" type="number" id="pincode" name="pincode"
                                  value={Orderinputs.pincode}
                                  onChange={handleOrderChange} />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-4">
                                <label className="form-label" htmlFor="state">
                                  State
                                  {/* {getStateName} */}
                                </label>
                                <select class="form-select border w-100 p-2 px-3" id="state" name="state" value={Orderinputs.state} onChange={(e) => { handleOrderChange(e); fetchtaxData(e.target.value); setStateName(e.target.options[e.target.selectedIndex].getAttribute('name')); setPrimaryName(e.target.options[e.target.selectedIndex].getAttribute('primary')) }}  >
                                  <option selected > {loading ? "Loading..." : "Select State"}</option>
                                  {data.map(item => (
                                    <option key={item.id} value={item._id} name={item.name} primary={item.primary} >{item.name}</option>
                                  ))};



                                </select>


                              </div>
                            </div>


                          </div>


                          <div className="col-12">
                            <label className="form-label" htmlFor="address">
                              Full Address
                            </label>
                            <textarea class="form-control" id="address" rows="3"
                              name="address"
                              value={Orderinputs.address}
                              onChange={handleOrderChange}
                            ></textarea>

                          </div>
                        </>
                      ) : (<>

                        <div id="wrapper">

                          <div class="profile-main-loader d-flex align-items-center justify-content-center" style={{ height: '50vh' }}>
                            <div class="spinner-border" role="status" style={{ width: 150, height: 150 }} />

                          </div>

                        </div>



                      </>)}


                    </>
                    ) : (<>

                      {/* 
                      <h6 className="pb-4 mb-4 border-bottom">Shipping address</h6>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="mb-4">
                            <label className="form-label" htmlFor="billing-fn">
                              First Name
                            </label>
                            <input className="form-control" type="text" id="billing-fn" />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-4">
                            <label className="form-label" htmlFor="billing-ln">
                              Last Name
                            </label>
                            <input className="form-control" type="text" id="billing-ln" />
                          </div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <label className="form-label" htmlFor="billing-company">
                          Company Name
                        </label>
                        <input className="form-control" type="text" id="billing-company" />
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="mb-4">
                            <label className="form-label" htmlFor="billing-email">
                              Email
                            </label>
                            <input className="form-control" type="email" id="billing-email" />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-4">
                            <label className="form-label" htmlFor="billing-phone">
                              Phone Number
                            </label>
                            <input className="form-control" type="text" id="billing-phone" />
                          </div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <label className="form-label" htmlFor="billing-country">
                          Country
                        </label>
                        <select className="form-select" id="billing-country">
                          <option value="">Choose country</option>
                          <option value="Australia">Australia</option>
                          <option value="Canada">Canada</option>
                          <option value="Finland">France</option>
                          <option value="Mexico">Mexico</option>
                          <option value="Switzerland">Switzerland</option>
                          <option value="United States">United States</option>
                        </select>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="mb-4">
                            <label className="form-label" htmlFor="billing-state">
                              State
                            </label>
                            <select className="form-select" id="billing-state">
                              <option value="">Choose state</option>
                              <option value="Australia">Australia</option>
                              <option value="Canada">Canada</option>
                              <option value="Finland">France</option>
                              <option value="Mexico">Mexico</option>
                              <option value="Switzerland">Switzerland</option>
                              <option value="United States">United States</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-4">
                            <label className="form-label" htmlFor="billing-zip">
                              Zip / Postal Code
                            </label>
                            <input className="form-control" type="text" id="billing-zip" />
                          </div>
                        </div>
                        <div className="mb-4">
                          <label className="form-label" htmlFor="billing-address-1">
                            Address 1
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            id="billing-address-1"
                          />
                        </div>
                        <div className="mb-8">
                          <label className="form-label" htmlFor="billing-address-2">
                            Address 2
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            id="billing-address-2"
                          />
                        </div>
                      </div>
                       */}


                    </>)}







                  </div>

                </>

              )}


              {(currentStep === 1 && isLogin) && (
                <>
                  <div className=' position-fixed start-0 bottom-0 border-0 shadow-sm w-100 p-2 bg-white' style={{ zIndex: 99 }} >

                    {cartItems && cartItems.length > 0 ? (
                      <button className="btn btn-primary w-100" onClick={handleNext}  >
                        Proceed to Payment</button>
                    ) : (
                      <Link className="btn btn-primary w-100" to="/">Shop Now</Link>
                    )}


                  </div>

                </>

              )}

              <div className=" mt-8">


                {currentStep === 2 && (
                  <div className='menubar-area footer-fixed p-2 bg-white d-flex gap-2' >

                    <button className="btn btn-dark w-20" onClick={handlePrevious}>
                      <i className="ri-arrow-left-s-line me-2" />
                      Back
                    </button>

                    {(Headers.cash !== 'true' && Headers.razorpay !== 'true') ?

                      <button type="button" disabled className="btn btn-secondary w-100"  >
                        Place Order
                      </button>
                      : <button type="button" className="btn btn-secondary w-100" onClick={handleOrderSubmit}    >
                        Place Order
                      </button>}
                  </div>
                )}

              </div>

            </div>





          </div>

        </div>

        <br />
        <br />

      </main >





    </>
  )
}

export default Checkout